import React, {useEffect, useRef, useState} from 'react';
import { useReactToPrint } from 'react-to-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './ResultPage2.css';

/*const scores = {
    '공격성': 7,
    '사회불안': 5,
    '우울': 8,
    '대인회피': 6,
    '자존감': 9,
    '정서불안': 4,
    '애정결핍': 7,
    '열등감': 5,
    '퇴행': 8,
};*/

const maxScores = {
    '공격성': 12,
    '대인회피': 8,
    '사회불안': 15,
    '애정결핍': 12,
    '열등감': 14,
    '우울': 15,
    '자존감': 18,
    '정서불안': 21,
    '퇴행': 10,
};

const data = {
    drawing_analysis: localStorage.getItem('drawing_analysis'),
    psychological_status: localStorage.getItem('psychological_status'),
    healing_methods: localStorage.getItem('healing_methods'),
};

const drawDynamicNonagon = (canvas, scores, maxScores) => {
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerX = width / 2;
    const centerY = height / 2;
    const maxRadius = Math.min(width, height) / 2.8; // 다각형 반경을 줄여 외곽 공간 확보
    const sides = 9;
    const angleStep = (2 * Math.PI) / sides;
    const scoreValues = Object.values(scores);
    const maxScoreValues = Object.values(maxScores);
    const scoreLabels = Object.keys(scores);

    // Clear the canvas
    ctx.clearRect(0, 0, width, height);

    // Draw the base polygon (guide lines)
    ctx.beginPath();
    for (let i = 0; i <= sides; i++) {
        const angle = i * angleStep;
        const x = centerX + maxRadius * Math.cos(angle);
        const y = centerY + maxRadius * Math.sin(angle);
        if (i === 0) {
            ctx.moveTo(x, y);
        } else {
            ctx.lineTo(x, y);
        }
    }
    ctx.closePath();
    ctx.strokeStyle = '#ddd';
    ctx.lineWidth = 1;
    ctx.stroke();

    // Draw the dynamic polygon based on percentages
    ctx.beginPath();
    scoreValues.forEach((score, i) => {
        const percentage = score / maxScoreValues[i]; // Calculate percentage
        console.log(scoreValues);
        console.log(score);
        console.log(maxScoreValues[i]);
        console.log(percentage);
        const angle = i * angleStep;
        const radius = percentage * maxRadius; // Scale radius by percentage
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);
        if (i === 0) {
            ctx.moveTo(x, y);
        } else {
            ctx.lineTo(x, y);
        }
    });
    ctx.closePath();
    ctx.strokeStyle = '#007BFF';
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.fillStyle = 'rgba(0, 123, 255, 0.2)';
    ctx.fill();

    // Draw the labels for each point
    scoreValues.forEach((score, i) => {
        const percentage = score / maxScoreValues[i]; // Calculate percentage
        const angle = i * angleStep;
        const radius = maxRadius ; // 라벨을 다각형 외곽에서 더 멀리 배치
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        // Draw the label (score and percentage)
        ctx.font = '14px Arial'; // 글씨 크기를 조정
        ctx.fillStyle = '#333';
        ctx.textAlign = 'center';
        ctx.fillText(
            `${scoreLabels[i]}: ${Math.round(percentage * 100)}%`,
            x,
            y
        );
    });
};


const ResultPage2 = () => {
    const canvasRef = useRef(null);
    const [scores, setScores] = useState(null);

    const pageRef = useRef(null); // PDF 저장할 영역

    const handleDownloadPdf = async () => {
        if (!pageRef.current) return;

        // 페이지 캡처
        const canvas = await html2canvas(pageRef.current);
        const imgData = canvas.toDataURL('image/png');

        // PDF 생성
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('result.pdf'); // PDF 저장
    };


    useEffect(() => {
        // Fetch scores from localStorage
        const personResponse = localStorage.getItem('personResponse');
        if (personResponse) {
            const parsedData = JSON.parse(personResponse);
            if (parsedData?.data?.scores) {
                setScores(parsedData.data.scores);
            }
        }
    }, []);

    useEffect(() => {
        if (scores) {
            drawDynamicNonagon(canvasRef.current, scores, maxScores);
            console.log(scores);
        }
    }, [scores]);



    if (!scores) {
        return <div>Loading...</div>;
    }

    return (
        <div ref={pageRef} className="result-page"> {/* PDF로 저장할 콘텐츠 */}
            <nav className="container-fluid">
                <ul>
                    <li><strong>캐치! 그림핑</strong></li>
                </ul>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="#">About</a></li>
                    <li><a href="#">Services</a></li>
                    <li><a href="#" role="button">Contact</a></li>
                </ul>
            </nav>

            <main className="container2">
                <h2>HTP 검사 결과</h2>
                <p>아래는 당신의 HTP 검사 결과입니다. 각 점수는 도형의 꼭짓점에 표시됩니다.</p>

                <div className="nonagon-container">
                    <h3>9각형 도형 (점수 기반)</h3>
                    <canvas ref={canvasRef} width="400" height="400" className="nonagon-canvas"></canvas>
                </div>

                <section className="report-section">
                    <h3>HTP Result Report</h3>
                    <p>아동의 HTP 검사를 기반으로 심리 상태를 분석한 결과입니다</p>
                    <ul>
                        <li><strong>그림 요소 분석:</strong> {data.drawing_analysis}</li>
                        <li><strong>아동 심리 상태:</strong> {data.psychological_status}</li>
                        <li><strong>챗봇과의 대화 내역 및 치유 방법:</strong> {data.healing_methods}</li>
                    </ul>
                </section>

                <div className="button-container">
                    <a href="/" className="button-1">돌아가기</a>
                    <button onClick={handleDownloadPdf} className="button-1">PDF 저장</button>
                </div>
            </main>
        </div>
    );
};

export default ResultPage2;
